module.exports = __webpack_public_path__ + "static/comparison-carousel-ed9c77da551a3051363084c29d4a9330.svg";